export enum ECheckUpPropertyTypes {
  ABDOMINAL_CIRCUMFERENCE = 'Circunferência Abdominal',
  ARTERIAL_PRESSURE = 'Pressão Arterial',
  TRIGLYCERIDES = 'Triglicérides',
  HDL_CHOLESTEROL = 'Colesterol HDL',
  GLYCEMIA = 'Glicemia',
  METABOLIC_SYNDROME = 'Síndrome Metabólica',
  UNRECOGNIZED = ''
}

export enum ECheckUpPropertyUnits {
  CM = 'cm',
  MMHG = 'mmHg',
  MG_DL = 'mg/dL',
  NONE = ''
}

export enum ECheckUpSimulationParams {
  NONE = 'nenhum',
  HIGHER_IPAQ = 'ipaq',
  LOWER_IMC = 'imc',
  BOTH = 'ambos'
}

export enum ECheckUpSensitivityParams {
  HIGH = 90,
  MEDIUM = 80,
  LOW = 70
}

export interface CheckUpPropertyMeasurement {
  date: string
  isAltered: boolean
  medicationUse?: boolean
  simulationResult?: number
  type: ECheckUpPropertyTypes
  unit: ECheckUpPropertyUnits
  value: string
}

// -------------------------------------

interface IPathParams {
  patientId: number
}

interface IQueryParams {
  sensitivity: ECheckUpSensitivityParams
  simulation: ECheckUpSimulationParams
}

export interface IFetchCheckUpPropertiesParams {
  pathParams: IPathParams
  queryParams: IQueryParams
}
